module.exports = __webpack_public_path__ + "img/logo-codemotion.56d52705.svg";